/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-unknown-property */
import React, { useState, useEffect, useRef } from 'react';
import style from '../../../../assets/styles/ImportQuestions.module.css';
import AuthLayout from '../../../../layout/AuthLayout';
import RightPanelTopMenu from '../../common/RightPanelTopMenu';
import { useNavigate, useLocation } from 'react-router-dom';
import { CallWithAuth } from '../../../../action/apiActions';
import { GET_QUESTIONBANK } from '../../../../action/apiPath';
import { useToast } from '../../common/Toast';
import closeIcon from '../../../../assets/images/closeSvgIcon.svg';
const svgIconForDownload = ` <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 15.4115C11.8795 15.4115 11.7673 15.3923 11.6635 15.3538C11.5597 15.3154 11.4609 15.2494 11.3672 15.1558L8.25775 12.0463C8.10908 11.8974 8.03567 11.7233 8.0375 11.524C8.0395 11.3247 8.11292 11.1474 8.25775 10.9922C8.41292 10.8373 8.59108 10.7572 8.79225 10.752C8.99358 10.7468 9.17183 10.8218 9.327 10.977L11.25 12.9V5.25C11.25 5.03717 11.3218 4.859 11.4655 4.7155C11.609 4.57183 11.7872 4.5 12 4.5C12.2128 4.5 12.391 4.57183 12.5345 4.7155C12.6782 4.859 12.75 5.03717 12.75 5.25V12.9L14.673 10.977C14.8218 10.8283 14.9984 10.7549 15.2028 10.7568C15.4072 10.7588 15.5871 10.8373 15.7423 10.9922C15.8871 11.1474 15.9621 11.3231 15.9672 11.5192C15.9724 11.7154 15.8974 11.8911 15.7423 12.0463L12.6328 15.1558C12.5391 15.2494 12.4403 15.3154 12.3365 15.3538C12.2327 15.3923 12.1205 15.4115 12 15.4115ZM6.30775 19.5C5.80258 19.5 5.375 19.325 5.025 18.975C4.675 18.625 4.5 18.1974 4.5 17.6923V15.7308C4.5 15.5179 4.57183 15.3398 4.7155 15.1962C4.859 15.0526 5.03717 14.9808 5.25 14.9808C5.46283 14.9808 5.641 15.0526 5.7845 15.1962C5.92817 15.3398 6 15.5179 6 15.7308V17.6923C6 17.7692 6.03208 17.8398 6.09625 17.9038C6.16025 17.9679 6.23075 18 6.30775 18H17.6923C17.7692 18 17.8398 17.9679 17.9038 17.9038C17.9679 17.8398 18 17.7692 18 17.6923V15.7308C18 15.5179 18.0718 15.3398 18.2155 15.1962C18.359 15.0526 18.5372 14.9808 18.75 14.9808C18.9628 14.9808 19.141 15.0526 19.2845 15.1962C19.4282 15.3398 19.5 15.5179 19.5 15.7308V17.6923C19.5 18.1974 19.325 18.625 18.975 18.975C18.625 19.325 18.1974 19.5 17.6923 19.5H6.30775Z" fill="#00ABFB" />
</svg>`;

const svgIconForChooseFile = ` <svg width="117" height="44" viewBox="0 0 117 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 28C0 36.8366 7.16344 44 16 44H101C109.837 44 117 36.8366 117 28V16C117 7.16344 109.837 0 101 0H16C7.16344 0 0 7.16344 0 16V28Z" fill="#7090B0" fill-opacity="0.3" />
                                    <path d="M25.872 27.168C24.5933 27.168 23.59 26.7387 22.862 25.88C22.134 25.012 21.77 23.7567 21.77 22.114C21.77 21.2927 21.8633 20.5693 22.05 19.944C22.2367 19.3187 22.5073 18.7913 22.862 18.362C23.2167 17.9327 23.646 17.6107 24.15 17.396C24.6633 17.172 25.2373 17.06 25.872 17.06C26.7213 17.06 27.4307 17.2467 28 17.62C28.5787 17.9933 29.0313 18.544 29.358 19.272L28.028 20C27.86 19.5333 27.5987 19.1647 27.244 18.894C26.8987 18.614 26.4413 18.474 25.872 18.474C25.116 18.474 24.5233 18.7307 24.094 19.244C23.6647 19.7573 23.45 20.4667 23.45 21.372V22.856C23.45 23.7613 23.6647 24.4707 24.094 24.984C24.5233 25.4973 25.116 25.754 25.872 25.754C26.46 25.754 26.936 25.6047 27.3 25.306C27.6733 24.998 27.9487 24.606 28.126 24.13L29.4 24.9C29.0733 25.6093 28.616 26.1647 28.028 26.566C27.44 26.9673 26.7213 27.168 25.872 27.168ZM30.965 16.64H32.491V20.924H32.561C32.7197 20.532 32.9577 20.2053 33.275 19.944C33.6017 19.6827 34.045 19.552 34.605 19.552C35.3517 19.552 35.9304 19.7993 36.341 20.294C36.761 20.7793 36.971 21.4747 36.971 22.38V27H35.445V22.562C35.445 21.4327 34.9877 20.868 34.073 20.868C33.877 20.868 33.681 20.896 33.485 20.952C33.2984 20.9987 33.1304 21.0733 32.981 21.176C32.8317 21.2787 32.7104 21.4093 32.617 21.568C32.533 21.7267 32.491 21.9087 32.491 22.114V27H30.965V16.64ZM41.9421 27.168C41.4381 27.168 40.9761 27.0793 40.5561 26.902C40.1455 26.7247 39.7955 26.4727 39.5061 26.146C39.2168 25.81 38.9928 25.4087 38.8341 24.942C38.6755 24.466 38.5961 23.9387 38.5961 23.36C38.5961 22.7813 38.6755 22.2587 38.8341 21.792C38.9928 21.316 39.2168 20.9147 39.5061 20.588C39.7955 20.252 40.1455 19.9953 40.5561 19.818C40.9761 19.6407 41.4381 19.552 41.9421 19.552C42.4461 19.552 42.9035 19.6407 43.3141 19.818C43.7341 19.9953 44.0888 20.252 44.3781 20.588C44.6675 20.9147 44.8915 21.316 45.0501 21.792C45.2088 22.2587 45.2881 22.7813 45.2881 23.36C45.2881 23.9387 45.2088 24.466 45.0501 24.942C44.8915 25.4087 44.6675 25.81 44.3781 26.146C44.0888 26.4727 43.7341 26.7247 43.3141 26.902C42.9035 27.0793 42.4461 27.168 41.9421 27.168ZM41.9421 25.908C42.4648 25.908 42.8848 25.7493 43.2021 25.432C43.5195 25.1053 43.6781 24.62 43.6781 23.976V22.744C43.6781 22.1 43.5195 21.6193 43.2021 21.302C42.8848 20.9753 42.4648 20.812 41.9421 20.812C41.4195 20.812 40.9995 20.9753 40.6821 21.302C40.3648 21.6193 40.2061 22.1 40.2061 22.744V23.976C40.2061 24.62 40.3648 25.1053 40.6821 25.432C40.9995 25.7493 41.4195 25.908 41.9421 25.908ZM49.8445 27.168C49.3405 27.168 48.8785 27.0793 48.4585 26.902C48.0478 26.7247 47.6978 26.4727 47.4085 26.146C47.1192 25.81 46.8952 25.4087 46.7365 24.942C46.5778 24.466 46.4985 23.9387 46.4985 23.36C46.4985 22.7813 46.5778 22.2587 46.7365 21.792C46.8952 21.316 47.1192 20.9147 47.4085 20.588C47.6978 20.252 48.0478 19.9953 48.4585 19.818C48.8785 19.6407 49.3405 19.552 49.8445 19.552C50.3485 19.552 50.8058 19.6407 51.2165 19.818C51.6365 19.9953 51.9912 20.252 52.2805 20.588C52.5698 20.9147 52.7938 21.316 52.9525 21.792C53.1112 22.2587 53.1905 22.7813 53.1905 23.36C53.1905 23.9387 53.1112 24.466 52.9525 24.942C52.7938 25.4087 52.5698 25.81 52.2805 26.146C51.9912 26.4727 51.6365 26.7247 51.2165 26.902C50.8058 27.0793 50.3485 27.168 49.8445 27.168ZM49.8445 25.908C50.3672 25.908 50.7872 25.7493 51.1045 25.432C51.4218 25.1053 51.5805 24.62 51.5805 23.976V22.744C51.5805 22.1 51.4218 21.6193 51.1045 21.302C50.7872 20.9753 50.3672 20.812 49.8445 20.812C49.3218 20.812 48.9018 20.9753 48.5845 21.302C48.2672 21.6193 48.1085 22.1 48.1085 22.744V23.976C48.1085 24.62 48.2672 25.1053 48.5845 25.432C48.9018 25.7493 49.3218 25.908 49.8445 25.908ZM57.2008 27.168C56.5102 27.168 55.9315 27.0467 55.4648 26.804C54.9982 26.5613 54.5922 26.2253 54.2468 25.796L55.2268 24.9C55.4975 25.2267 55.7962 25.4833 56.1228 25.67C56.4588 25.8473 56.8462 25.936 57.2848 25.936C57.7328 25.936 58.0642 25.852 58.2788 25.684C58.5028 25.5067 58.6148 25.264 58.6148 24.956C58.6148 24.7227 58.5355 24.5267 58.3768 24.368C58.2275 24.2 57.9615 24.0927 57.5788 24.046L56.9068 23.962C56.1602 23.8687 55.5722 23.654 55.1428 23.318C54.7228 22.9727 54.5128 22.464 54.5128 21.792C54.5128 21.4373 54.5782 21.1247 54.7088 20.854C54.8395 20.574 55.0215 20.3407 55.2548 20.154C55.4975 19.958 55.7822 19.8087 56.1088 19.706C56.4448 19.6033 56.8135 19.552 57.2148 19.552C57.8682 19.552 58.4002 19.6547 58.8108 19.86C59.2308 20.0653 59.6042 20.35 59.9308 20.714L58.9928 21.61C58.8062 21.386 58.5588 21.1947 58.2508 21.036C57.9522 20.868 57.6068 20.784 57.2148 20.784C56.7948 20.784 56.4822 20.868 56.2768 21.036C56.0808 21.204 55.9828 21.4233 55.9828 21.694C55.9828 21.974 56.0715 22.184 56.2488 22.324C56.4262 22.464 56.7108 22.5667 57.1028 22.632L57.7748 22.716C58.5775 22.8373 59.1608 23.0753 59.5248 23.43C59.8982 23.7753 60.0848 24.242 60.0848 24.83C60.0848 25.1847 60.0148 25.5067 59.8748 25.796C59.7442 26.076 59.5528 26.3187 59.3008 26.524C59.0488 26.7293 58.7455 26.888 58.3908 27C58.0362 27.112 57.6395 27.168 57.2008 27.168ZM64.6648 27.168C64.1421 27.168 63.6755 27.0793 63.2648 26.902C62.8541 26.7247 62.5041 26.4727 62.2148 26.146C61.9255 25.81 61.7015 25.4087 61.5428 24.942C61.3935 24.466 61.3188 23.9387 61.3188 23.36C61.3188 22.7813 61.3935 22.2587 61.5428 21.792C61.7015 21.316 61.9255 20.9147 62.2148 20.588C62.5041 20.252 62.8541 19.9953 63.2648 19.818C63.6755 19.6407 64.1421 19.552 64.6648 19.552C65.1968 19.552 65.6635 19.6453 66.0648 19.832C66.4755 20.0187 66.8161 20.28 67.0868 20.616C67.3575 20.9427 67.5581 21.3253 67.6888 21.764C67.8288 22.2027 67.8988 22.674 67.8988 23.178V23.752H62.9008V23.99C62.9008 24.55 63.0641 25.012 63.3908 25.376C63.7268 25.7307 64.2028 25.908 64.8188 25.908C65.2668 25.908 65.6448 25.81 65.9528 25.614C66.2608 25.418 66.5221 25.152 66.7368 24.816L67.6328 25.698C67.3621 26.146 66.9701 26.5053 66.4568 26.776C65.9435 27.0373 65.3461 27.168 64.6648 27.168ZM64.6648 20.742C64.4035 20.742 64.1608 20.7887 63.9368 20.882C63.7221 20.9753 63.5355 21.106 63.3768 21.274C63.2275 21.442 63.1108 21.6427 63.0268 21.876C62.9428 22.1093 62.9008 22.366 62.9008 22.646V22.744H66.2888V22.604C66.2888 22.044 66.1441 21.596 65.8548 21.26C65.5655 20.9147 65.1688 20.742 64.6648 20.742ZM73.0087 27V17.228H79.1127V18.628H74.5907V21.344H78.6087V22.744H74.5907V27H73.0087ZM81.6511 18.418C81.3337 18.418 81.1004 18.3433 80.9511 18.194C80.8111 18.0447 80.7411 17.8533 80.7411 17.62V17.382C80.7411 17.1487 80.8111 16.9573 80.9511 16.808C81.1004 16.6587 81.3337 16.584 81.6511 16.584C81.9684 16.584 82.1971 16.6587 82.3371 16.808C82.4771 16.9573 82.5471 17.1487 82.5471 17.382V17.62C82.5471 17.8533 82.4771 18.0447 82.3371 18.194C82.1971 18.3433 81.9684 18.418 81.6511 18.418ZM80.8811 19.72H82.4071V27H80.8811V19.72ZM86.1401 27C85.6175 27 85.2255 26.8693 84.9641 26.608C84.7121 26.3373 84.5861 25.964 84.5861 25.488V16.64H86.1121V25.754H87.1201V27H86.1401ZM91.4343 27.168C90.9117 27.168 90.445 27.0793 90.0343 26.902C89.6237 26.7247 89.2737 26.4727 88.9843 26.146C88.695 25.81 88.471 25.4087 88.3123 24.942C88.163 24.466 88.0883 23.9387 88.0883 23.36C88.0883 22.7813 88.163 22.2587 88.3123 21.792C88.471 21.316 88.695 20.9147 88.9843 20.588C89.2737 20.252 89.6237 19.9953 90.0343 19.818C90.445 19.6407 90.9117 19.552 91.4343 19.552C91.9663 19.552 92.433 19.6453 92.8343 19.832C93.245 20.0187 93.5857 20.28 93.8563 20.616C94.127 20.9427 94.3277 21.3253 94.4583 21.764C94.5983 22.2027 94.6683 22.674 94.6683 23.178V23.752H89.6703V23.99C89.6703 24.55 89.8337 25.012 90.1603 25.376C90.4963 25.7307 90.9723 25.908 91.5883 25.908C92.0363 25.908 92.4143 25.81 92.7223 25.614C93.0303 25.418 93.2917 25.152 93.5063 24.816L94.4023 25.698C94.1317 26.146 93.7397 26.5053 93.2263 26.776C92.713 27.0373 92.1157 27.168 91.4343 27.168ZM91.4343 20.742C91.173 20.742 90.9303 20.7887 90.7063 20.882C90.4917 20.9753 90.305 21.106 90.1463 21.274C89.997 21.442 89.8803 21.6427 89.7963 21.876C89.7123 22.1093 89.6703 22.366 89.6703 22.646V22.744H93.0583V22.604C93.0583 22.044 92.9137 21.596 92.6243 21.26C92.335 20.9147 91.9383 20.742 91.4343 20.742Z" fill="#272727" />
                                </svg>`;

const ImportQuestions: React.FC = () => {
  const [buttonText, setButtonText] = useState('Import'); // Initial text is "Import"
  const [file, setFile] = useState<File | null>(null);
  const [questionFile, setQuestionFile] = useState<File | null>(null);
  const [solutionFile, setSolutionFile] = useState<File | null>(null);
  const [mappingFile, setMappingFile] = useState<File | null>(null);
  const [uploadStatus] = useState<string | null>(null);
  const navigate = useNavigate();
  const toast = useToast();
  const BASE_URL: any = process.env.REACT_APP_API_KEY;
  const location = useLocation();
  const {
    doc_id,
    name: locationName,
    current_question_bank: questionset,
    current_question_bank_id,
  } = location.state || {}; // If state is passed, use it; otherwise, fallback to empty.
  const [name, setName] = useState(locationName || ''); // If name is passed, use it. If not, default to empty string
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  const [docId] = useState(doc_id || ''); // If doc_id is passed, use it. If not, default to empty string.
  const [currentQuestionBank, setCurrentQuestionBank] = useState(questionset || '');
  const [isButtonDisabled, setIsButtonDisabled] = useState(false); // Track button disabled state
  const isReupload = !!name && !!doc_id; // Check if both name and doc_id are provided (Reupload case)
  const [questionBanks, setQuestionBanks] = useState<any[]>([]); // State to store fetched question banks
  const [questionBank, setQuestionBank] = useState<string>(current_question_bank_id); // State for selected question bank
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const questionFileInputRef = useRef<HTMLInputElement | null>(null);
  const solutionFileInputRef = useRef<HTMLInputElement | null>(null);
  const mappingFileInputRef = useRef<HTMLInputElement | null>(null);
  const [isModalVisible, setIsModalVisible] = useState(true); // Modal is visible initially
  const [organizationId, setOrganizationId] = useState<number | null>(() => {
    const storedId = localStorage.getItem('selectedOrgId');
    return storedId ? Number(storedId) : null;
  });

  // Function to close the modal
  const closeModal = () => {
    setIsModalVisible(false);
  };

  // Function to check form validity
  const checkFormValidity = () => {
    // Enable button only if all required fields are valid
    if (name.trim() && docId !== null && questionFile && solutionFile && mappingFile) {
      setIsButtonDisabled(false);
    } else {
      setIsButtonDisabled(true);
    }
  };

  // Use useEffect to track changes in the form inputs
  useEffect(() => {
    checkFormValidity();
    // Hide the modal if required fields are missing
    if (!name || !docId) {
      setIsModalVisible(false);
    }
  }, [name, docId, questionBank, file, questionFile, solutionFile, mappingFile]);

  const handleBackClick = () => {
    navigate('/document-logger');
  };

  const getQuestionBank = async () => {
    const url = GET_QUESTIONBANK + organizationId + '/?permission=true';
    const GetData: any = await CallWithAuth('GET', url);
    if (GetData.status && Array.isArray(GetData.res.data)) {
      // Sort the data alphabetically by the `name` property
      const sortedData = GetData.res.data.sort((a: any, b: any) => a.name.localeCompare(b.name));
      setQuestionBanks(sortedData);
    }
  };

  const getButtonClass = (buttonText: string, isButtonDisabled: boolean) => {
    if (buttonText === 'Loading...') return `${style.import_button} ${style.loading_class}`;
    if (isButtonDisabled) return `${style.import_button} ${style.disabled}`;
    return style.import_button;
  };
  useEffect(() => {
    getQuestionBank();
  }, []);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>, type: string) => {
    const selectedFile = event.target.files?.[0];
    if (!selectedFile) return; // Handle the case where no file is selected
    // Check file type and extensions
    const isDocx = selectedFile.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    const allowedExtensions = ['csv', 'xls', 'xlsx'];
    const fileExtension = selectedFile.name.split('.').pop()?.toLowerCase();
    switch (type) {
      case 'passage':
        if (isDocx) {
          setFile(selectedFile); // Set file for Passage Document
        } else {
          toast?.add('Only .docx files are supported.', 'error'); // Set error message
        }
        break;
      case 'question':
        if (isDocx) {
          setQuestionFile(selectedFile); // Set file for Question Document
        } else {
          toast?.add('Only .docx files are supported.', 'error'); // Set error message
        }
        break;
      case 'solution':
        if (isDocx) {
          setSolutionFile(selectedFile); // Set file for Solution Document
        } else {
          toast?.add('Only .docx files are supported.', 'error'); // Set error message
        }
        break;
      case 'mapping':
        if (fileExtension && allowedExtensions.includes(fileExtension)) {
          setMappingFile(selectedFile); // Set file for Mapping Document
        } else {
          toast?.add('Only .csv, .xls, .xlsx files are supported.', 'error'); // Set error message
        }
        break;
      default:
        break;
    }
    // Reset the file input to allow re-selection of the same file
    event.target.value = '';
  };

  // Helper function to handle and display server-side validation messages
  const handleServerValidationErrors = (response: any, toast: any) => {
    const errorMessage = response?.res?.data?.error || response?.data?.error;
    if (typeof errorMessage !== 'string') {
      // Format and display error messages from server validation
      const formattedErrors = Object.entries(errorMessage).map(
        ([field, messages]) => `${field}: ${(messages as string[]).join(', ')}`
      );
      toast?.remove('all');
      toast?.add(formattedErrors[0], 'error');
    } else {
      toast?.add(errorMessage, 'error');
    }
  };
  const reupload = async (formData: any) => {
    const reuploadUrl = `${BASE_URL}word_doc/${doc_id}/reupload/`;
    const response = await CallWithAuth('POST', reuploadUrl, formData);
    if (response?.res?.status === 200) {
      const successMessage = response?.res?.data?.message;
      if (toast) {
        toast.add(successMessage, 'success');
      }
      clearFields(['name']); // Exclude 'name' field from being cleared
    } else {
      handleServerValidationErrors(response, toast);
      setIsButtonDisabled(false); // Re-enable button if validation errors occur
    }
    return response;
  };
  const createFormData = (name: any) => {
    const formData = new FormData();
    formData.append('name', name);
    formData.append('question_bank', questionBank);
    if (organizationId !== null) {
      formData.append('org_id', organizationId.toString());
    }
    if (file) formData.append('passage_document', file);
    if (questionFile) formData.append('question_document', questionFile);
    if (solutionFile) formData.append('solution_document', solutionFile);
    if (mappingFile) formData.append('mapping_sheet', mappingFile);
    formData.forEach((value, key) => {
      if (value instanceof File) {
        // eslint-disable-next-line no-console
        console.log(`${key}: ${value.name}`); // Log file name
      } else {
        // eslint-disable-next-line no-console
        console.log(`${key}: ${value}`); // Log other values
      }
    });
    return formData;
  };
  // Main handleImport function
  const handleImport = async (name: string, doc_id: number | null) => {
    const formData = createFormData(name);
    let response;
    try {
      setButtonText('Loading...'); // Change text to "Loading..." immediately
      setIsButtonDisabled(true); // Disable button to prevent multiple API hits
      if (doc_id && name.trim()) {
        await reupload(formData);
      } else {
        const defaultUrl = `${BASE_URL}word_doc/`;
        response = await CallWithAuth('POST', defaultUrl, formData);
        if (response?.res?.status === 200) {
          navigate('/document-logger');
          const successMessage = response?.res?.data?.message;
          if (toast) {
            toast.add(successMessage, 'success');
          }
          clearFields();
        } else {
          handleServerValidationErrors(response, toast);
          setIsButtonDisabled(false); // Re-enable button if validation errors occur
        }
      }
    } catch (error: any) {
      const errorMessage = error.response?.data?.error || 'An error occurred while uploading.';
      if (toast) {
        toast.add(errorMessage, 'error');
      }
      setIsButtonDisabled(false); // Re-enable button on error
    } finally {
      setButtonText('Import'); // Reset button text
      setIsButtonDisabled(false); // Re-enable button after the process
    }
  };

  const clearFields = (excludeFields: string[] = []) => {
    // Only clear fields not included in the excludeFields array
    if (!excludeFields.includes('name')) setName(''); // Reset name state
    if (!excludeFields.includes('questionBank')) setQuestionBank(''); // Reset question bank state
    if (!excludeFields.includes('currentQuestionBank')) setCurrentQuestionBank(''); // Reset current question bank state
    if (!excludeFields.includes('file')) setFile(null); // Reset passage file
    if (!excludeFields.includes('questionFile')) setQuestionFile(null); // Reset question document
    if (!excludeFields.includes('solutionFile')) setSolutionFile(null); // Reset solution document
    if (!excludeFields.includes('mappingFile')) setMappingFile(null); // Reset mapping sheet

    // Clear file inputs unless excluded
    if (!excludeFields.includes('fileInput') && fileInputRef.current) fileInputRef.current.value = '';
    if (!excludeFields.includes('questionFileInput') && questionFileInputRef.current)
      questionFileInputRef.current.value = '';
    if (!excludeFields.includes('solutionFileInput') && solutionFileInputRef.current)
      solutionFileInputRef.current.value = '';
    if (!excludeFields.includes('mappingFileInput') && mappingFileInputRef.current)
      mappingFileInputRef.current.value = '';
  };

  const handleCancel = () => {
    if (docId && name) {
      // Reuploading case - Only clear specific files
      setFile(null);
      setQuestionFile(null);
      setSolutionFile(null);
      setMappingFile(null);
    } else {
      // Importing case - Clear all fields
      setName('');
      setQuestionBank('');
      setFile(null);
      setQuestionFile(null);
      setSolutionFile(null);
      setMappingFile(null);
    }
  };

  const handleDownload = async (fileType: 'mapping_sheet' | 'passage_doc' | 'question_doc' | 'solution_doc') => {
    const url = `${BASE_URL}word_doc_logger/sample_download/${fileType}/`;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) {
        const errorData = await response.json();
        if (toast) {
          toast.add(errorData.error || 'Download failed', 'error');
        }
        return;
      }
      const blob = await response.blob();
      const mimeToExtension = {
        'text/csv': 'csv',
        'application/vnd.ms-excel': 'xls',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
        'application/octet-stream': 'xlsx', // Fallback MIME type
      };
      const defaultExtensions = {
        mapping_sheet: 'xlsx', // Default to xlsx for mapping_sheet
        passage_doc: 'docx',
        question_doc: 'docx',
        solution_doc: 'docx',
      };
      // Determine the file extension dynamically or fallback to default
      const fileExtension = mimeToExtension[blob.type as keyof typeof mimeToExtension] || defaultExtensions[fileType];
      if (!fileExtension) {
        if (toast) {
          toast.add('Unsupported file type received.', 'error');
        }
        return;
      }
      // Trigger the download
      const downloadUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = `${fileType}.${fileExtension}`;
      document.body.appendChild(a);
      a.click();
      // Clean up the created URL object after download
      URL.revokeObjectURL(downloadUrl);
      document.body.removeChild(a);
    } catch (error) {
      if (toast) {
        toast.add('Download failed. Please try again later.', 'error');
      }
    }
  };

  return (
    <>
      <AuthLayout>
        <RightPanelTopMenu
          setQuestionBankId={null}
          title={'Import Questions'}
          setOrganisationId={(id: number) => setOrganizationId(id)}
        />
        <button
          className={style.import_back_button}
          onClick={handleBackClick}
          onKeyDown={(e) => e.key === 'Enter' && handleBackClick()}
          style={{ background: 'none', border: 'none' }}
        >
          <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M16.4023 19.422L9.88687 12.902C9.11741 12.132 9.11741 10.872 9.88687 10.102L16.4023 3.58203"
              stroke="#212529"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Back
        </button>
        <div className={style.import_questions}>
          <h2 className={style.import_title}>{name && docId ? 'Reupload Questions' : 'Import Questions'}</h2>
          <div className={style.inline_fields}>
            <div className={`${style.input_field} ${style.name_group}`}>
              <label className={style.nameLabel} htmlFor="name">
                Name <span className={style.required_name}>*</span>
              </label>
              <input
                type="text"
                id="name"
                placeholder="Enter name"
                value={name} // Controlled input field for name
                onChange={(e) => setName(e.target.value)} // Update name state on input change
                disabled={isReupload} // Disable if it's the reupload case (both name and doc_id are provided)
              />
            </div>
            <div className={`${style.input_field} ${style.question_bank_group}`}>
              <label className={style.questionBankLabel} htmlFor="questionBank">
                Question Bank <span className={style.required_questionbank}>*</span>
              </label>
              <select
                id="questionBank"
                className={`${style['custom_question_bank']} ${questionBank ? style.selected : ''} ${style['select_qb_text']} ${questionBank ? style.selectedColor : ''}`}
                value={questionBank || current_question_bank_id || ''} // Set initial value correctly
                onChange={(e) => {
                  const selectedBankId = e.target.value;
                  setQuestionBank(selectedBankId); // Update the question bank state
                }}
              >
                {/* Default option displaying the current question bank */}
                <option value={current_question_bank_id || ''}>{currentQuestionBank || 'Select question bank'}</option>
                {/* Dynamically render other question banks excluding the current question bank */}
                {questionBanks
                  .filter((bank) => bank.name !== currentQuestionBank) // Exclude the current question bank
                  .map((bank) => (
                    <option key={bank.id} value={bank.id}>
                      {bank.name}
                    </option>
                  ))}
              </select>
            </div>
          </div>
          {/* Passage Document */}
          <div className={`${style.input_field} ${style.passage_document_group}`}>
            <div className={style.file_input_header}>
              <label htmlFor="passage">Passage Document</label>
              <button className={style.sample_file_button} onClick={() => handleDownload('passage_doc')}>
                <div className={style.svg_download_div} dangerouslySetInnerHTML={{ __html: svgIconForDownload }} />
                Download Sample File
              </button>
            </div>
            <p className={style.docx_support_text}>Only Supports .Docx Files</p>
            <div className={style.file_input_container}>
              <input
                type="file"
                accept=".docx"
                onChange={(e) => handleFileChange(e, 'passage')}
                className={style.file_input}
                id="fileInput_passage" // Unique ID for passage
                style={{ display: 'none' }} // Hiding the file input
              />
              <button
                className={style.file_input_icon}
                onClick={() => document.getElementById('fileInput_passage')?.click()}
              >
                <div dangerouslySetInnerHTML={{ __html: svgIconForChooseFile }} />
              </button>
              <p className={style.file_name_text}>{file && `${file?.name}`}</p>
            </div>
          </div>
          {/* Question Document */}
          <div className={`${style.input_field} ${style.question_document_group}`}>
            <div className={style.file_input_header}>
              <label htmlFor="Question">
                Question Document <span className={style.required_name}>*</span>
              </label>
              <button className={style.sample_file_button} onClick={() => handleDownload('question_doc')}>
                <div className={style.svg_download_div} dangerouslySetInnerHTML={{ __html: svgIconForDownload }} />
                Download Sample File
              </button>
            </div>
            <p className={style.docx_support_text}>Only Supports .Docx Files</p>
            <div className={style.file_input_container}>
              <input
                type="file"
                accept=".docx"
                onChange={(e) => handleFileChange(e, 'question')}
                className={style.file_input}
                id="fileInput_question" // Unique ID for question
                style={{ display: 'none' }} // Hiding the file input
              />
              <button
                className={style.file_input_icon}
                onClick={() => document.getElementById('fileInput_question')?.click()}
              >
                <div dangerouslySetInnerHTML={{ __html: svgIconForChooseFile }} />
              </button>
              <p className={style.file_name_text}>{questionFile && `${questionFile?.name}`}</p>
            </div>
          </div>
          {/* Solution Document */}
          <div className={`${style.input_field} ${style.solution_document_group}`}>
            <div className={style.file_input_header}>
              <label htmlFor="solution">
                Solution Document <span className={style.required_name}>*</span>
              </label>
              <button className={style.sample_file_button} onClick={() => handleDownload('solution_doc')}>
                <div className={style.svg_download_div} dangerouslySetInnerHTML={{ __html: svgIconForDownload }} />
                Download Sample File
              </button>
            </div>
            <p className={style.docx_support_text}>Only Supports .Docx Files</p>
            <div className={style.file_input_container}>
              <input
                type="file"
                accept=".docx"
                onChange={(e) => handleFileChange(e, 'solution')}
                className={style.file_input}
                id="fileInput_solution" // Unique ID for solution
                style={{ display: 'none' }} // Hiding the file input
              />
              <button
                className={style.file_input_icon}
                onClick={() => document.getElementById('fileInput_solution')?.click()}
              >
                <div dangerouslySetInnerHTML={{ __html: svgIconForChooseFile }} />
              </button>
              <p className={style.file_name_text}>{solutionFile && `${solutionFile?.name}`}</p>
            </div>
          </div>
          {/* Mapping Document */}
          <div className={`${style.input_field} ${style.mapping_sheet_group}`}>
            <div className={style.file_input_header}>
              <label htmlFor="mapping">
                Mapping Sheet <span className={style.required_name}>*</span>
              </label>
              <button className={style.sample_file_button} onClick={() => handleDownload('mapping_sheet')}>
                <div className={style.svg_download_div} dangerouslySetInnerHTML={{ __html: svgIconForDownload }} />
                Download Sample File
              </button>
            </div>
            <p className={style.docx_support_text}>Only Supports .CSV, .XLS, .XLSX Files</p>
            <div className={style.file_input_container}>
              <input
                type="file"
                accept=".xlsx"
                onChange={(e) => handleFileChange(e, 'mapping')}
                className={style.file_input}
                id="fileInput_mapping" // Unique ID for mapping
                style={{ display: 'none' }} // Hiding the file input
              />
              <button
                className={style.file_input_icon}
                onClick={() => document.getElementById('fileInput_mapping')?.click()}
              >
                <div dangerouslySetInnerHTML={{ __html: svgIconForChooseFile }} />
              </button>
              <p className={style.file_name_text}>{mappingFile && `${mappingFile?.name}`}</p>
            </div>
          </div>
        </div>
        <div className={style.action_buttons}>
          <button className={style.cancel_button} onClick={handleCancel}>
            Cancel
          </button>
          <button
            className={getButtonClass(buttonText, isButtonDisabled)}
            onClick={() => handleImport(name, docId)} // Pass the required arguments explicitly
            disabled={isButtonDisabled || buttonText === 'Loading...'} // Disable when "Loading..."
          >
            {buttonText}
          </button>
        </div>
        <div className={style.upload_status}>{uploadStatus && <p>{uploadStatus}</p>}</div>
      </AuthLayout>
      {/* New modal for reminderModal */}
      {isModalVisible && (
        <div className={`${style.modal} ${style.reminder_modal} ${style.reminder_modal_visible}`}>
          <div className={style.reminder_modal_header}>
            <p>Important Reminder</p>
            <button
              onKeyDown={(e) => e.key === 'Enter' && closeModal()}
              className={style.modalClose}
              onClick={closeModal}
              style={{ background: 'none', border: 'none', padding: '0px' }}
            >
              <img src={closeIcon} alt="Close" />
            </button>
          </div>
          <div className={style.reminder_modal_body}>
            <p>
              Please be sure to click the ‘Update Exam’ button in the ‘Test Papers’ Tab to update the changes across all
              tests that include these questions.
            </p>
          </div>
          <div>
            <button className={style.reminder_modal_buttons} onClick={closeModal}>
              Got it!
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ImportQuestions;
